import React from "react";

/* eslint-disable react/prop-types */

export const ModalSizeContext = React.createContext({
  maxHeight: null,
  fixedHeight: null
});

// This function takes a component...
export function withModalSizeContext(Component) {
  // ...and returns another component...
  const ModalSizeComponent = props => {
    // ... and renders the wrapped component with the ContainerContext
    // Notice that we pass through any additional props as well

    const { forwardedRef, ...rest } = props;

    return (
      <ModalSizeContext.Consumer>
        {maxSizeContext => {
          return (
            <Component
              ref={forwardedRef}
              {...rest}
              maxHeight={maxSizeContext.maxHeight}
              fixedHeight={maxSizeContext.fixedHeight}
            />
          );
        }}
      </ModalSizeContext.Consumer>
    );
  };

  return React.forwardRef((props, ref) => {
    return <ModalSizeComponent {...props} forwardedRef={ref} />;
  });
}
